import { controls } from "../controls";

const dcollector = {
  label: "Home",
  pageLabel: "Dashboard",
  starting: true,
  url: "home",
  pageType: "history",
  dashboard: [
    ...controls.displayText({ width: "col-sm-12", label: " ", tab: "filter" }),
    // {
    //   widths: "col-sm-4",
    //   tab: "create",
    //   // theme: "orotheme",
    //   title: "Getting Started icon-selfWhatsApp",
    //   footer: "one time activity",
    //   selfWhatsApp: "sendsummary",
    //   subComponents: [
    //     ...controls.kpiList({
    //       name: "kpi_list1",
    //       values: [
    //         { main: { desc: "Bank Details", url: "bank", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "Branches", url: "branches", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "Zones", url: "rbi_mis_nos", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "GL", url: "gls", value: "icon-tick", color: "#8af07f" } },
    //         { main: { desc: "GL Map", url: "groups", value: " ", color: "#ff4646" } },
    //         { main: { desc: "ATM", value: "13", color: "#8af07f" } },
    //       ]
    //     }),
    //   ]
    // },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Upload Transfer Request - CBS icon-selfWhatsApp",
      footer: "For money transfer",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Natural Calamity", url: "upload_dbtls", value: "10/12/2021", color: "green" } },
            { main: { desc: "Niradhar Nidhi", url: "upload_dbtls", value: " ", color: "red" } },
            { main: { desc: "Other", url: "upload_dbtls", value: " ", color: "red" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      title: "Status icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "Success & return rate of uploaded files.",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Natural Calamity", url: "rpc1", value: "10/12/2021", color: "green" } },
            { main: { desc: "Niradhar Nidhi", url: "gls", value: " ", color: "red" } },
            { main: { desc: "Other", url: "gls", value: " ", color: "red" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Reports icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "Reports for internal and state level compliance",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Taluka Wise Brief", url: "report_acceptances", value: " ", color: "red" } },
            { main: { desc: "Taluka Wise Detailed", url: "report_acceptances", value: "12/12/2021", color: "green" } },
            { main: { desc: "Gender Wise Brief", url: "report_acceptances", value: " ", color: "red" } },
            { main: { desc: "Gender Wise Detailed", url: "report_acceptances", value: " ", color: "red" } },
            { main: { desc: "Scheme Wise Brief", url: "report_acceptances", value: " ", color: "red" } },
            { main: { desc: "Scheme Wise Detailed", url: "report_acceptances", value: " ", color: "red" } },
            { main: { desc: "Customized Reports", url: "report_acceptances", value: " ", color: "red" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Taluka Wise icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "for the current quarter",
      subComponents: [
        ...controls.gchart({
          charttype: "pie1"
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Caste Wise icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "for the current quarter",
      subComponents: [
        ...controls.gchart({
          charttype: "castebar"
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Gender Wise icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "for the current quarter",
      subComponents: [
        ...controls.gchart({
          charttype: "pie3"
        }),
      ]
    },





  ]
};

export default dcollector;